(() => {
  if (window.ksPujoHomeLoaded) return;
  window.ksPujoHomeLoaded = true;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const coupon = root.querySelector('[data-copy]');
    coupon?.addEventListener('click', async () => {
      const status = root.querySelector('[aria-live="polite"].sr');
      try {
        await navigator.clipboard.writeText(coupon.dataset.copy);
        coupon.querySelector('span').textContent = 'Copied';
        if (status) status.textContent = 'Coupon copied';
      } catch {
        coupon.querySelector('span').textContent = 'Use this code at checkout';
      }
    });
    const stock = root.querySelector('[data-pujo-stock]');
    const reserve = root.querySelector('[data-pujo-reserve]');
    if (!stock || !reserve) return;
    const deadline = Date.parse(root.querySelector('[data-deadline]')?.dataset.deadline);
    let controller, busy = false, inView = false;
    function closeIfDue() {
      if (Number.isFinite(deadline) && Date.now() > deadline) {
        stock.querySelector('strong').textContent = root.dataset.closedLabel;
        reserve.textContent = root.dataset.closedLabel;
        reserve.setAttribute('aria-disabled', 'true');
        reserve.setAttribute('tabindex', '-1');
        return true;
      }
      return false;
    }
    async function refresh() {
      if (document.hidden || !inView || busy || !root.isConnected || closeIfDue()) return;
      busy = true;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('_stock', Date.now().toString());
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
        if (!response.ok) throw new Error('Availability unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-pujo-stock]');
        const freshButton = doc.querySelector('[data-pujo-reserve]');
        if (!fresh || !freshButton) throw new Error('No availability');
        stock.replaceChildren(...Array.from(fresh.childNodes));
        reserve.textContent = freshButton.textContent;
        for (const name of ['aria-disabled','tabindex']) {
          if (freshButton.hasAttribute(name)) reserve.setAttribute(name, freshButton.getAttribute(name));
          else reserve.removeAttribute(name);
        }
        closeIfDue();
      } catch {
        if (root.isConnected) stock.querySelector('strong').textContent = root.dataset.stockError;
      } finally {clearTimeout(timeout);busy = false;}
    }
    reserve?.addEventListener('click', e => {if (closeIfDue() || reserve.getAttribute('aria-disabled') === 'true') e.preventDefault();});
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView) refresh();
    }, {rootMargin:'150px'});
    observer.observe(stock);
    const timer = setInterval(refresh, 30000);
    function visible() {if (!document.hidden) refresh();}
    function unload(e) {
      if (e.target.contains(root)) {
        clearInterval(timer);controller?.abort();observer.disconnect();
        document.removeEventListener('visibilitychange', visible);
        document.removeEventListener('shopify:section:unload', unload);
      }
    }
    document.addEventListener('visibilitychange', visible);
    document.addEventListener('shopify:section:unload', unload);
    closeIfDue();
  }
  document.querySelectorAll('[data-pujo-home]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-pujo-home]').forEach(init));
})();
